import e from"react";const t=e.createContext({isMobile:!1,experiments:{},languageDir:"ltr"});export{t as GlobalContext};
//# sourceMappingURL=contexts.js.map
